<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="flex" style="align-items: center;">
        <span>排课数据</span>
        <div class="flex_1"></div>
        <el-button plain @click="batchAdd" size="mini">批量新增</el-button>
        <text-button
          icon="el-icon-refresh"
          contentTit="刷新"
          @click.native="search"
        ></text-button>
        <text-button
          icon="el-icon-setting"
          contentTit="列设置"
          :colSetting="colSetting"
          @update="update"
          :ispopover="true"
          :baseColSetting="baseColSetting"
        ></text-button>
      </div>

      <el-table-bar fixed :static="true">
        <el-table
          :key="tableKey"
          :data="dataList"
          fit
          :highlight-current-row="true"
          @sort-change="tableSortAll"
          :default-sort="{ prop: 'start_time', order: 'ascending' }"
        >
        <!-- style="margin-top: 15px;" -->
          <el-table-column
            v-for="item of defaultHeader"
            :key="item.label"
            :label="item.label"
            :align="item.align ? item.align : 'left'"
            :min-width="item.width ? item.width : 'auto'"
            :sortable="item.sortable ? item.sortable : false"
            :prop="item.prop"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <template v-if="item.label === '上课时间'">
                <span >
                  <span>（{{scope.row.start_time.substring(0, 10) | weekDay}}）</span>
                  {{ scope.row.start_time | formatDateStart }} {{scope.row.end_time | formatDateEnd }}</span>
              </template>
              <template v-else-if="item.label === '课堂任务'">
                <el-row v-if="scope.row.courseUnitlist.length != 0" :key="index" v-for="(item,index) in scope.row.courseUnitlist">
                  <span>{{item.title}}</span>
                </el-row>
                <el-row v-if="scope.row.courseUnitlist.length == 0">
                  <span>无</span>
                </el-row>
              </template>
              <template v-else-if="item.label === '排课操作'">
                <el-button type="text"  @click.native="editLess(scope.row)">编辑排课</el-button>
              </template>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-table-bar>

      <el-pagination
        class="fr-pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizes"
        :page-size="pagination.pageSize"
        :layout="pagination.layout"
        :total="pagination.total"
      ></el-pagination>

    </el-card>

    <add-lesson
      :addlessonData="addlessonData"
      :show="dialogLesson"
      :campusId="classInfo.campus_id"
      :classInfo="classInfo"
      @close="close"
      @editLessonForm="editLessonForm"
      @getClassMessage="getLessonInfoByClassId"
    ></add-lesson>
    <!-- 批量增加排课 -->
    <batch-add :show="batchDialog" @close="batchDialog=false" @getClassMessage="getLessonInfoByClassId" :classInfo="classInfo"></batch-add>
  </div>
</template>

<script>
import TextButton from '@/components/TextButton'
import SearchQuery from '@/components/SearchQuery'
import batchAdd from '../batch-add/index'
import getStateColor from '@/mixins/getStateColor'
import addLesson from '../add-lesson/index'

import { listCourseUnit, getLessonInfoByClassId,lessonEdit } from '@/api/merchantClass'

// 默认展示列
const baseColSetting = [
  {
    label: '上课时间',
    prop: 'start_time',
    state: true,
    sortable: true,
    align: 'center',
    width: '255',
  },
  {
    label: '课堂任务',
    prop: 'courseUnitlist',
    state: true,
    align: 'center',
    width: '150',
  },
  {
    label: '排课状态',
    prop: 'finished_status',
    state: true,
    align: 'center',
    width: '100',
  },
  {
    label: '排课操作',
    state: true,
    align: 'center',
    width: '150',
  },
]
export default {
  props: {
    classInfo: {
      default: () => {
        return {}
      },
      type: Object
    },pageFrom:{
      default: '',
      type: String
    },
  },
  mixins: [getStateColor],
  components: {TextButton, SearchQuery,batchAdd,addLesson},
  data() {
    return {
      dialogLesson:false,
      colSetting: JSON.parse(JSON.stringify(baseColSetting)), // 表格展示列
      baseColSetting: JSON.parse(JSON.stringify(baseColSetting)),
      pagination: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 40],
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      },
      dataList: [],
      tableKey: 1,
      isDesc: false, // 列表默认为正序
      product_id: this.$route.query.productId, // 收费课程id
      lessonDialog: false,
      courseUnitIdList: [],
      lesson_id: '',
      classId: '',
      addlessonData: null,
      batchDialog: false,
      DeedBackDialog: false,
      attendanceDialog: false,
      schooltime: '', // 上课时间
      stuList: [], // 学员列表
      dialogJionLive: false,
      liveRoomId: '',
      dialogCode: false,
      dialogLive: false,
      lessonLiveName: '',
      liveData: null,
      lessonLiveData: null,
    }
  },
  created () {
    this.getLessonInfoByClassId()
  },
  computed: {
    defaultHeader() {
      return this.colSetting.filter(item => item.state)
    },
  },
  methods: {
    // 编辑排课
    async editLessonForm (data) {
      let editLesson = {
        id: data.id,
        start_time: data.start_time,
        end_time: data.endTime,
      }
      const res = await lessonEdit({ ...editLesson })
      if (res.state === 'success') {
        window.$msg('编辑成功')
        this.getLessonInfoByClassId()
        this.close()
      } else {
        if (res.errCode === '0201001') {
          this.clashFun(res)
        }
      }
      // this.mapCourseUnits(data.id,data.courseUnitId)
      // this.getCourseUnitList();
    },
    async getLessonInfoByClassId () { // 获取班级排课列表
      const res = await getLessonInfoByClassId({
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        class_id: this.$route.query.classID,
        isDesc: this.isDesc
      })
      const dataList = res.body.list

      this.dataList = dataList
      this.pagination.total = res.body.total
    },

    jumpLive (row) {
      this.liveRoomId = row.liveId
      this.dialogJionLive = true
    },

    update(data) {
      this.tableKey = this.tableKey + 1
      if (data.lenght !== 0) {
        this.colSetting.forEach(item => {
          item.state = false
          data.forEach(ele => {
            if (ele === item.label && !item.state) {
              item.state = true
            }
          })
        })
      } else {
        this.colSetting = []
      }
    },

    // 批量排课
    batchAdd () {
      this.batchDialog = true
    },

    search() {
      this.pagination.currentPage = 1
      this.getLessonInfoByClassId()
    },

    // 时间排序
    tableSortAll(column) {
      switch (column.order) {
        case 'ascending':
          this.isDesc = false
          break
        case 'descending':
          this.isDesc = true
      }
      this.getLessonInfoByClassId()
    },

    // 分页
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getLessonInfoByClassId()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getLessonInfoByClassId()
    },

    getStateColor (state) {
      switch (state) {
        case '已上课':
          return '#4DA54D'
        case '未上课':
          return '#f56c6c'
        default:
          return '#C8C6C6'
      }
    },

    // 编辑排课
    editLess (row) {
      if(row.finished_status === '已上课') {
        window.$msg('已上课的排课不能编辑排课',2)
        return false
      }else if(row.finished_status === '正在上课') {
        window.$msg('正在上课的排课不能编辑排课',2)
        return false
      }
      let studentIds = []
      if (this.stuList.length !== 0) {
        this.stuList.map(item => {
          studentIds.push(item.user_id)
        })
      }
      this.class_id = row.class_id
      this.addlessonData = row
      this.dialogLesson = true
    },

    close() {
      this.dialogLesson = false
    },
  },

}
</script>

<style lang="scss" scoped>
@import '../../../style/container.scss';
</style>
